var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSessionsAverage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DCFCE7;}\n\t.st1{fill:#3CD855;}\n\t.st2{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50,
    cy: 50,
    r: 38.9
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.3,61.8c-5.3,0-7.4-6.1-9.4-12.1c-1.9-5.7-3.9-11.5-8.2-11.5c-2.1,0.1-3.8,1.5-4.5,3.4l-2.8-0.9 c0.1-0.2,1.9-5.4,7.3-5.4c6.4,0,8.8,7.1,11,13.4c1.8,5.2,3.5,10.1,6.7,10.1c2.1-0.1,3.8-1.5,4.5-3.4l2.8,0.9 C67.5,56.6,65.7,61.8,60.3,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.3,67.7V51.5h2.9v-2.9h-2.9V29.4h-2.9v38.3c0,1.6,1.3,2.9,2.9,2.9h38.3v-2.9H32.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.2,
    y: 48.5,
    className: "st1",
    width: 2.9,
    height: 2.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.1,
    y: 48.5,
    className: "st1",
    width: 2.9,
    height: 2.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9,
    y: 48.5,
    className: "st1",
    width: 2.9,
    height: 2.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 48.5,
    className: "st1",
    width: 2.9,
    height: 2.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.7,
    y: 48.5,
    className: "st1",
    width: 2.9,
    height: 2.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    x: 26.4,
    y: 26.4,
    className: "st2",
    width: 47.1,
    height: 47.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionsAverage);
export default __webpack_public_path__ + "static/media/sessions-average.5bf45845ae78e4b7e87644b9897e2a52.svg";
export { ForwardRef as ReactComponent };